// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"758":"32c0c4","798":"e3487d","811":"2b45d9","970":"5e4ae7"}[chunkId] + ".css";
};